export default __webpack_public_path__ + "b6b136a2fa7181a769da3a7e3464f8d0.svg";